// extracted by mini-css-extract-plugin
export default {"modalTitle":"modalTitle--AWN2s","tip":"tip--gaL4w","status":"status--v5lHX","circle":"circle--ZftBS"};